import { LinearProgress, Stack } from "@mui/material";
import { take } from "lodash";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../auth/AuthContext";
import InfiniteScroll from "../components/infiniteScroll/InfiniteScroll";
import { useLimit } from "../misc/useLimit";
import { useOpenInNewTab } from "../misc/useOpenInNewTab";
import ECommerceOfferCard from "./ECommerceOfferCard";
import ECommerceSearch from "./ECommerceSearch";
import { useECommerceSearch } from "./useECommerceSearch";
import { useFilteredECommerceOffers } from "./useFilteredECommerceOffers";

const ECommerceOffersPage = () => {
  const navigate = useNavigate();
  const { context } = useAuthContext();
  const { openInNewTab } = useOpenInNewTab();
  const { limit, loadMore } = useLimit();
  const { searchCriteria, setSearchCriteria, clear } = useECommerceSearch();
  const { offers, isLoading } = useFilteredECommerceOffers(searchCriteria);

  const role = context?.role;

  return (
    <Stack
      spacing={1}
      sx={{
        marginTop: 1,
        paddingBottom: 1,
        height: "100%",
      }}
    >
      <ECommerceSearch value={searchCriteria} onChange={setSearchCriteria} onClear={clear} />
      {isLoading && <LinearProgress />}
      <InfiniteScroll
        dataLength={limit < offers.length ? limit : offers.length}
        fetchData={loadMore}
        hasMore={limit < offers.length}
      >
        {take(offers, limit).map((o) => (
          <ECommerceOfferCard
            key={o.id.value}
            value={o}
            role={role}
            onClick={() => navigate(`/e-commerce/${o.id.value}`)}
            onContextMenu={() => openInNewTab(`/orders/${o.id.value}`)}
          />
        ))}
      </InfiniteScroll>
    </Stack>
  );
};

export default ECommerceOffersPage;
